import { AxiosResponse } from "axios";

import apiClient from "../../../../shared/infrastructure/api/client";
import type { EmdrSetDraft, EmdrSetRecord } from "../../domain/emdrSets";

/** A session's EMDR set records: SUD, VOC and note per set. */
export const EmdrSetsAPI = {
    list: (sessionId: string): Promise<AxiosResponse<EmdrSetRecord[]>> =>
        apiClient.get(`/sessions/${sessionId}/emdr-sets`),

    record: (sessionId: string, draft: EmdrSetDraft): Promise<AxiosResponse<EmdrSetRecord>> =>
        apiClient.post(`/sessions/${sessionId}/emdr-sets`, draft),

    remove: (sessionId: string, recordId: string): Promise<AxiosResponse<void>> =>
        apiClient.delete(`/sessions/${sessionId}/emdr-sets/${recordId}`),
};
